import { useQuery } from "@tanstack/react-query";
import { getAllClients } from "@/api";
import { useAuth } from "@/contexts";
import { EsoClient } from "@/types";

export const useDealManagerClients = () => {
  const { user } = useAuth()
  const query = useQuery<EsoClient[]>({
    queryKey: ["dealManagerClients"],
    queryFn: () => getAllClients(),
    // Deal-manager-only endpoint: it answers 403 for anyone else. Kept gated so
    // a client never spends a round trip on a call that cannot succeed. Rules of
    // Hooks means this runs even on renders that bail out later, so the gate
    // belongs here rather than at the call site.
    enabled: user?.userType === "deal_manager",
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};